import PropTypes from 'prop-types';
import { memo } from 'react';
import { useLocation } from 'react-router-dom';
// @mui
import { Stack } from '@mui/material';
//
import { NavListRoot } from './NavList';
import useAdminInfoStore from 'src/store/admin';
import SvgIconStyle from 'src/components/SvgIconStyle';

import { PATH_DASHBOARD } from 'src/routes/paths';
import useProjectInfoStore from 'src/store/project';

// ----------------------------------------------------------------------

const hideScrollbar = {
  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  overflowY: 'scroll',
  '&::-webkit-scrollbar': {
    display: 'none',
  },
};

NavSectionHorizontal.propTypes = {
  navConfig: PropTypes.array,
};

function NavSectionHorizontal({ navConfig }) {
  const { adminInfo } = useAdminInfoStore();

  const { pathname } = useLocation();
  const { projectInfo } = useProjectInfoStore();

  const menuItems = adminInfo?.Menu;

  const projectId = projectInfo?.ApplicationID;
  const projectTitle = `پروژه ${projectInfo?.ApplicationTitle}`;

  const newMenuItem = {
    ProfileUACMenuID: null,
    ProfileUACMenuProfileID: null,
    ProfileUACMenuTitle: projectTitle,
    ProfileUACMenuUrl: pathname?.includes('project/') ? '/' : '/null-pathname',
    ProfileUACMenuIcon: 'project',
    ProfileUACMenuIsDefaultRoute: null,
  };

  if (projectInfo) {
    if (menuItems[2]?.ProfileUACMenuTitle?.includes('پروژه')) {
      menuItems[2] = newMenuItem;
    } else {
      menuItems.splice(2, 0, newMenuItem);
    }
  }

  const manipulatedNavConfig = [
    {
      items: menuItems?.map((item) => {
        return {
          title: item?.ProfileUACMenuTitle,
          path: item?.ProfileUACMenuUrl,
          icon: <SvgIconStyle src={`/icons/ic_${item?.ProfileUACMenuIcon}.svg`} sx={{ width: 1, height: 1 }} />,
          ...(item?.ProfileUACMenuTitle === projectTitle && {
            children: [
              { title: 'سکشن ها', path: PATH_DASHBOARD.general.appSectionList(projectId) },
              { title: 'بسته محتواها', path: PATH_DASHBOARD.general.projectFeedList(projectId) },
              { title: 'بنرها و اعلانات', path: PATH_DASHBOARD.general.notificationBannerTypeList(projectId) },
              { title: 'تورنومنت ها', path: PATH_DASHBOARD.general.duelList(projectId) },
              // { title: 'لیدربرد ها', path: PATH_DASHBOARD.general.leaderBoardList(projectId) },
              { title: 'گردونه ها', path: PATH_DASHBOARD.general.wheelList(projectId) },
              { title: 'پاداش مشاهده ویدیو', path: PATH_DASHBOARD.general.mediaRewards(projectId) },
            ],
          }),
        };
      }),
    },
  ];

  return (
    <Stack direction="row" justifyContent="center" sx={{ bgcolor: 'background.neutral', borderRadius: 1, px: 0.5 }}>
      <Stack direction="row" sx={{ ...hideScrollbar, py: 1 }}>
        {manipulatedNavConfig.map((group) => (
          <Stack key={group.subheader} direction="row" flexShrink={0}>
            {group.items.map((list) => (
              <NavListRoot key={list.title} list={list} />
            ))}
          </Stack>
        ))}
      </Stack>
    </Stack>
  );
}

export default memo(NavSectionHorizontal);
